module.exports = __webpack_public_path__ + "img/fileImport.fe8834a.png";